
// Image imports
import NewsletterImg from "./../../images/blogs/JJF Magazine -March 2026 (Volume 19).pdf (3).jpg";

import InstagramIcon from "./../../images/social-icons/instagram.png";
import LinkedinIcon from "./../../images/social-icons/linkedin.png";
import FacebookIcon from "./../../images/social-icons/facebook.png";
import YoutubeIcon from "./../../images/social-icons/youtube.png";
import XIcon from "./../../images/social-icons/x.png";
import ThreadIcon from "./../../images/social-icons/threads.png";
import PintrestIcon from "./../../images/social-icons/pintrest.png";
import MediumIcon from "./../../images/social-icons/medium.png";

// CSS Imports
import "./blogs.css";

export default function BlogSidebar() {
    
    return (
        <div className="sidebar-container">
            {/* Magzine Image */}
            <div className="sidebar-section" >
                <div>
                    <h3 className="sidebar-title" >MONTHLY MAGAZINE</h3>
                </div>
                <div>
                    <a target="_blank" rel="noopener noreferrer" href="https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-March-2026-(Volume+-19).pdf.pdf">
                        <img src={NewsletterImg} alt="JJF Magazine March 2026 (Volume 19) cover" />
                    </a>
                </div>
            </div>
            
            <div className="sidebar-sub-container">
            {/* Social media icons */}
                <div className="sidebar-section" >
                    <h3 className="sidebar-title">Social media icons</h3>
                    <div className="sidebar-social">
                        <a  target="_blank" rel="noopener noreferrer" className="sidebar-social-link"  href="https://www.instagram.com/TeamJJFIndia/">
                            <img src={InstagramIcon} alt="Instagram" />
                        </a>
                        
                        <a target="_blank" rel="noopener noreferrer" className="sidebar-social-link"  href="https://www.linkedin.com/company/TeamJJFIndia/">
                            <img src={LinkedinIcon} alt="LinkedIn" />
                        </a>

                        <a target="_blank" rel="noopener noreferrer" className="sidebar-social-link"  href="https://www.facebook.com/TeamJJFIndia/">
                            <img src={FacebookIcon} alt="Facebook" />
                        </a>

                        <a  target="_blank" rel="noopener noreferrer" className="sidebar-social-link" href="https://www.youtube.com/@TeamJJFIndia/">
                            <img src={YoutubeIcon} alt="YouTube" />
                        </a>
                        
                        <a target="_blank" rel="noopener noreferrer" className="sidebar-social-link"  href="https://x.com/TeamJJFIndia/">
                            <img src={XIcon} alt="X" />
                        </a>

                        <a target="_blank" rel="noopener noreferrer" className="sidebar-social-link"  href="https://www.threads.net/@TeamJJFIndia/">
                            <img src={ThreadIcon} alt="Threads" />
                        </a>


                        <a  target="_blank" rel="noopener noreferrer" className="sidebar-social-link" href="https://in.pinterest.com/TeamJJFIndia/">
                            <img src={PintrestIcon} alt="Pinterest" />
                        </a>

                        <a target="_blank" rel="noopener noreferrer" className="sidebar-social-link"  href="https://medium.com/@TeamJJFIndia">
                            <img src={MediumIcon} alt="Medium" />
                        </a>

                    </div>
                </div>

                {/* Popular blogs links */}
                <div className="sidebar-section" >
                    <h3 className="sidebar-title" >Popular blogs</h3>
                    <div className="sidebar-link-container">
                        <div>
                            <a href="/our-bulletin/the-pulse-of-change-beats" target="_blank" className="sidebar-link" >The Pulse of Change Beats Through Every Hand</a>
                        </div>
                        <div>
                            <a href="/our-bulletin/when-gratitude-finds" target="_blank" className="sidebar-link" >When Gratitude Finds Its Way Back</a>
                        </div>
                        
                        <div>
                            <a href="/our-bulletin/when-diyas-meet-hearts" target="_blank" className="sidebar-link" >When Diyas Meet Hearts: Celebrating Diwali with JJFIndia</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}